<template>
	<a-config-provider :locale="locale">
		<div id="app">
			<router-view v-slot="{ Component, route }">
				<transition :name="route.meta.transition">
					<component :is="Component" />
				</transition>
			</router-view>
			<!-- <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" v-if="keepAlive" />
        </keep-alive>
        <component :is="Component" />
      </router-view> -->

			<!-- <transition v-on:before-enter="beforeEnter" v-on:before-leave="beforeLeave" :name="fold">
      <router-view v-wechat-title="$route.meta.title" v-if="isRouterAlive" />
    </transition> -->
			<div class="authority-wrap" v-if="isKey">
				<div class="authority-box">
					<h1 class="title">注册验证</h1>
					<el-tabs v-model="activeName" class="demo-tabs">
						<el-tab-pane label="在线注册" name="first"></el-tab-pane>
						<el-tab-pane label="离线注册" name="second"></el-tab-pane>
					</el-tabs>
					<div v-show="activeName === 'first'">
						<el-form :model="form" label-width="auto" style="max-width: 600px">
							<el-form-item label="机器码：">
								<el-input v-model="form.mac_code" :disabled="true">
									<template #append>
										<el-button @click="handleCopyCode">复制</el-button>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="注册码">
								<el-input v-model="form.reg_code" type="textarea" />
							</el-form-item>
						</el-form>
					</div>
					<div v-show="activeName === 'second'">
						<el-form :model="form" label-width="auto" style="max-width: 600px">
							<el-form-item label="机器码：">
								<el-input v-model="form.mac_code" :disabled="true">
									<template #append>
										<el-button @click="handleCopyCode">复制</el-button>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="注册码">
								<el-input v-model="form.reg_code" type="textarea" />
							</el-form-item>
						</el-form>
					</div>
					<el-button type="primary" @click="onSubmit">确认</el-button>
				</div>
			</div>
		</div>
	</a-config-provider>
</template>

<script>
	import { defineComponent, nextTick, ref, getCurrentInstance, watch, reactive, onMounted, toRefs, onBeforeUnmount } from 'vue';
	import zh from 'ant-design-vue/lib/locale-provider/zh_CN';
	import en from 'ant-design-vue/lib/locale-provider/en_GB';
	import pt from 'ant-design-vue/lib/locale-provider/pt_PT';
	import es from 'ant-design-vue/lib/locale-provider/es_ES';
	import axiosData from 'axios/dist/axios.min.js';
	import JSEncrypt from 'jsencrypt';
	import { useStore } from 'vuex';
	import { setAuthorization, getAuthorization, checkAuthorization, removeAuthorization } from '@/utils/request';
	import { getSign } from '@/utils/signature';
	import { formatTime } from '@/utils/formatTime';
	export default defineComponent({
		name: 'App',
		setup() {
			const { proxy } = getCurrentInstance();
			let globalProperties = getCurrentInstance().appContext.config.globalProperties;
			const axios = globalProperties.$axioshanma;
			const user_id = localStorage.getItem('user_id') || '';

			const state = reactive({
				activeName: 'first',
				form: {
					reg_code: '',
					mac_code: ''
				},
				isKey: false
			});
			const store = useStore();
			onMounted(async () => {
				//存在对Electron应用的特殊处理
				if (process.env.VUE_APP_VERSION == 'electron') {
					let secretkey = localStorage.getItem('secretkey');
					try {
						// 发送IPC请求到主进程获取机器码
						const machineId = await window.electron.ipcRenderer.invoke('get-machine-id');
						state.form.mac_code = machineId;
						if (secretkey == machineId) {
							state.isKey = false;
						} else {
							state.isKey = true;
						}
					} catch (error) {
						console.error('Error getting machine ID:', error);
					}

					let inElectron = navigator.userAgent.toLowerCase().indexOf('electron') > -1;
					store.dispatch('setinElectron', inElectron);
				}

				// 网络状态
				// 首次加载时设置状态
				updateNetworkStatus();
				// 添加事件监听
				window.addEventListener('online', updateNetworkStatus);
				window.addEventListener('offline', updateNetworkStatus);

				// window.document.title = i18n.global.t(label)
				nextTick(() => {
					setTimeout(() => {
						// getMinFontsize();
						let label = proxy.$route.meta.label;
						window.document.title = proxy.$t(label);
						// console.log(proxy.$route.meta.label);
					}, 2000);
				});
			});
			onBeforeUnmount(() => {
				//存在对Electron应用的特殊处理
				if (process.env.VUE_APP_VERSION == 'electron') {
					window.removeEventListener('online', updateNetworkStatus);
					window.removeEventListener('offline', updateNetworkStatus);
				}
			});

			const getLanguage = () => {
				switch (proxy.$i18n.locale) {
					case 'zh':
						proxy.locale = zh;
						var label = proxy.$route.meta.label;
						window.document.title = proxy.$t(label);
						break;
					case 'en':
						proxy.locale = en;
						var label = proxy.$route.meta.label;
						window.document.title = proxy.$t(label);
						break;
					case 'pt':
						proxy.locale = pt;
						var label = proxy.$route.meta.label;
						window.document.title = proxy.$t(label);
						break;
					case 'es':
						proxy.locale = es;
						var label = proxy.$route.meta.label;
						window.document.title = proxy.$t(label);
						break;
					default:
						proxy.locale = zh;
				}
			};

			//以下方法 用于Electron应用
			// 更新网络状态的函数
			const updateNetworkStatus = () => {
				// store.dispatch('setInternet', navigator.onLine || true);
				// console.log('onLine', navigator.onLine);
				if (!navigator.onLine && !navigator.userAgent.includes('HarmonyOS')) {
					console.warn('网络已断开');
          store.commit('setGuest', false);
          store.commit('setOnline', false);
				} else {
          store.commit('setOnline', true);
					// 有网络且只有非游客模式下才获取用户信息
					const token = getAuthorization();
          const user_id = localStorage.getItem('user_id');
					if (token && user_id) {
						store.commit('setGuest', false);
            getUserInfo();
						getMemberUser();
					} else {
						store.commit('setGuest', true);
            removeAuthorization();
            localStorage.removeItem('user_id');
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
					}
				}
			};
			// 获取用户信息
			const getUserInfo = () => {
				var timestamp = Date.parse(new Date());
				timestamp = timestamp / 1000;
				let param = {
					timestamp,
					fun: 'hmUserInfo',
					requestType: 'User',
					appId: 'a0f0e723-f2bb-11e8-bc50-00163e0c395e',
					appKey: 'a0f12ce4-f2bb-11e8-bc50-00163e0c395e',
					userId: user_id
				};
				var signature = getSign(param);
				let obj = JSON.parse(JSON.stringify(param));
				obj.signature = signature;
				axios('/api/tem.distInterface/distData', obj).then(res => {
					store.commit('setUserInfo', res);
				});
			};
			// 获取会员信息
			const getMemberUser = () => {
				axios('/api/tem.app_member/getMemberUser', {
					user_id: user_id
				}).then(res => {
					let userMemberInfo = res;
					userMemberInfo.new_expire_time = formatTime(userMemberInfo.expire_time);
					store.commit('setMemberInfo', userMemberInfo);
				});
			};

			const handleCopyCode = () => {
				function copyTextToClipboard(text) {
					const textarea = document.createElement('textarea');
					textarea.value = text;
					document.body.appendChild(textarea);
					textarea.select();
					document.execCommand('copy');
					document.body.removeChild(textarea);
					message.success('复制成功');
				}
				copyTextToClipboard(state.form.mac_code);
			};
			///在Linux系统中使用机器码完成注册
			const onSubmit = async () => {
				if (state.activeName == 'first') {
					let host = 'http://registerkey.hprtcloud.com';
					axiosData.post(host + '/api/code_ap/activationValidation', state.form).then(res => {
						if (res.data.code == 200 || res.data.code == 201 || res.data.code == 203) {
							message.success(res.data.msg);
							state.isKey = false;
							localStorage.setItem('secretkey', state.form.mac_code);
						} else {
							message.error(res.data.msg);
						}
					});
				} else {
					const key1 = `-----BEGIN PRIVATE KEY-----
          MIIJQQIBADANBgkqhkiG9w0BAQEFAASCCSswggknAgEAAoICAQDS33Em2VN3G6t7
          `;
					const key2 = await window.electron.ipcRenderer.invoke('machine-verification');
					let publicKey = key1 + key2;
					const privateKeyEncryptedText = state.form.reg_code;
					const forceDecrypt = () => {
						const decryptor = new JSEncrypt();
						decryptor.setPublicKey(publicKey); //
						let decryptedText = decryptor.decrypt(privateKeyEncryptedText);
						let keyObj = JSON.parse(decryptedText);
						console.log(keyObj);
						if (!keyObj) {
							message.error('注册码错误');
							return;
						}
						if (keyObj.client_code == state.form.mac_code) {
							state.isKey = false;
							localStorage.setItem('secretkey', state.form.mac_code);
						} else {
							message.error('注册码错误');
						}
					};
					forceDecrypt();
				}
			};

			return {
				...toRefs(state),
				getLanguage,
				onSubmit,
				handleCopyCode,
				locale: ref(en)
			};
		}
	});
</script>
<style>
	html,
	body,
	#app {
		height: 100%;
	}
	.authority-wrap {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 999;
		left: 0;
		top: 0;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		/* display: none; */
	}

	.authority-box {
		width: 400px;
		border: 1px solid #ebeef5;
		text-align: center;
		padding: 40px;
		border-radius: 5px;
	}
</style>
